import type { StateCreator } from 'zustand'

interface FeedbackDialogBase {
  feedbackDialogOpen: boolean
  // Text the dialog opens with, for a request written for the person (a
  // LOINC panel Orbit cannot record yet).
  feedbackDraft: string
}

interface FeedbackDialogActions {
  setFeedbackDialogOpen: (
    nextOpen:
      | FeedbackDialogBase['feedbackDialogOpen']
      | ((
          currentOpen: FeedbackDialogBase['feedbackDialogOpen']
        ) => FeedbackDialogBase['feedbackDialogOpen'])
  ) => void
  // Opens the dialog with `draft` as its text.
  openFeedbackDialog: (draft: string) => void
}

export interface FeedbackDialogState
  extends FeedbackDialogBase, FeedbackDialogActions {}

export const createFeedbackDialogStore: StateCreator<FeedbackDialogState> = (
  set
) => ({
  feedbackDialogOpen: false,
  feedbackDraft: '',
  setFeedbackDialogOpen: (nextOpen) => {
    set((state) => {
      const open =
        typeof nextOpen === 'function'
          ? nextOpen(state.feedbackDialogOpen)
          : nextOpen
      const next: Partial<FeedbackDialogState> = {
        feedbackDialogOpen: open,
      }
      if (!open) {
        next.feedbackDraft = ''
      }
      return next
    })
  },
  openFeedbackDialog: (draft) => {
    set({ feedbackDialogOpen: true, feedbackDraft: draft })
  },
})
